import { Link } from "@tanstack/react-router";
import type { JSX } from "react";

import { GithubMark } from "@/components/icons";
import { ThemeMenu } from "@/components/ThemeMenu";
import { buttonVariants } from "@/components/ui/button";
import { cn } from "@/lib/utils";
import { GITHUB_URL } from "@/lib/site";

export const SiteHeader = (): JSX.Element => (
  <header className="sticky top-0 z-40 border-b border-border/60 bg-background/70 backdrop-blur-xl">
    <div className="mx-auto flex h-14 max-w-7xl items-center gap-3 px-4 sm:px-6">
      <Link to="/" className="flex items-center gap-2.5 rounded-full">
        <img src="/openvod.svg" alt="" width={26} height={26} className="shrink-0" />
        <span className="text-[15px] font-bold tracking-tight">OpenVOD</span>
      </Link>

      <div className="flex-1" />

      <a
        href={`${GITHUB_URL}#readme`}
        target="_blank"
        rel="noreferrer noopener"
        className={cn(buttonVariants({ variant: "ghost", size: "sm" }), "hidden sm:inline-flex")}
      >
        Docs
      </a>
      <a
        href={GITHUB_URL}
        target="_blank"
        rel="noreferrer noopener"
        className={cn(buttonVariants({ variant: "outline", size: "sm" }))}
      >
        <GithubMark className="size-4" />
        GitHub
      </a>
      <ThemeMenu />
    </div>
  </header>
);
